exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".swiper-slide img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  /*height: 7rem*/ }\n\n.focus {\n  position: relative; }\n\n.focus .swiper-slide a {\n  color: #fff; }\n\n.swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet,\n.swiper-pagination-custom .swiper-pagination-bullet, .swiper-pagination-fraction .swiper-pagination-bullet {\n  background-color: #fff; }\n\n.swiper-pagination-current {\n  font-size: 30px;\n  color: #f33; }\n\n.ceshi {\n  width: 100px;\n  height: 100px;\n  background: red; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/component/swiper/index.scss
// module id = 632
// module chunks = 0